import { CUBE_INSIGHT_PRODUCT } from '@/api/hcp/interaction/types';
import { INSIGHT_DATE_DIMENSION } from '@/pages/Insights/constants';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { FilterLimitPresets } from '../../filterDefaultLimits';
import { isNonEmptyStringArray } from '../../utils';
import mapDimensionToOption from '../../utils/mapDimensionToOption';

const DIMENSION = `${CUBE_INSIGHT_PRODUCT}.product`;

const insightProductFilter: FilterConfigDynamic = {
  label: 'main.insights.filters.labels.product',
  placeholder: 'main.insights.filters.labels.product',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  useFloatingLabel: true,
  sourceCube: CUBE_INSIGHT_PRODUCT,
  getOptionsQuery: ({ dateRange }) => ({
    dimensions: [DIMENSION],
    limit: FilterLimitPresets.LIMIT_5K,
    timeDimensions: [getDateRangeTimeDimension({ dateRange, dimension: INSIGHT_DATE_DIMENSION })],
  }),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    if (!isNonEmptyStringArray(value)) return undefined;

    return {
      member: DIMENSION,
      operator: 'equals',
      values: value,
    };
  },
};

export default insightProductFilter;
